/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleNavigation } from '../../actions';

const NavigationProjectTitle = ({
    projectTitle,
    showEditProjectInput,
    updateProjectTitle,
    setShowEditProjectTitle,
    saveProjectTitle,
    // setEnableBuilder,
    projectTitleError,
    showNavigation,
    dispatch,
}) => {
    const [initialLoad, setInitialLoad] = useState(true);
    const titleDefaultValue = projectTitle?.split('-')[0];
    const [projectTitleText, setProjectTitleText] = useState(titleDefaultValue);

    useEffect(() => {
        if (initialLoad) setInitialLoad(false);
    }, [initialLoad]);

    useEffect(() => {
        const titleDefaultValue = projectTitle ? projectTitle.split('-')[0] : '';
        setProjectTitleText(titleDefaultValue);
    }, [projectTitle]);

    useEffect(() => {
        if (showNavigation) {
            setShowEditProjectTitle(true);
        }
    }, [showNavigation, setShowEditProjectTitle]);

    return (
        <div className="navigation__projectTitle">
            <h3>Name your project</h3>
            {showEditProjectInput ? (
                <div className="navigation__projectTitle--inner">
                    <input
                        placeholder="Project name, e.g. ‘Matt's fig’"
                        type="text"
                        onChange={(projectTitle) => setProjectTitleText(projectTitle.target.value)}
                        className={`${projectTitleError ? 'error' : ''}`}
                        value={projectTitleText}
                    />
                    {projectTitleError && <p className="error">Please enter a project name to continue.</p>}

                    <button
                        type="button"
                        className="btn button span"
                        onClick={() => {
                            saveProjectTitle(projectTitleText);
                            if (showNavigation) {
                                dispatch(toggleNavigation());
                            }
                        }}
                    >
                        <span>Save & start building</span>
                    </button>
                </div>
            ) : (
                <>
                    <h3>Your project: {projectTitle?.split('-')[0]}</h3>
                    <button className="navigation__changeProjectTitle" type="button" onClick={setShowEditProjectTitle}>
                        Change name
                    </button>
                </>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        showNavigation: state.showNavigation,
    };
};

export default connect(mapStateToProps)(NavigationProjectTitle);
